/* @ngInject */
function HomeCampaignsItemController ($scope, ArtCollectionsService, CONSTANTS, Utils, TemplateService) {
  const api = {
    _successGetTemplates
  }
  this.getApi = () => api

  activate()

  function activate () {
    if ($scope.campaign) {
      if (!$scope.campaign.thumbnailS3Key) {
        ArtCollectionsService.getTemplatesById($scope.campaign.id, {}).then(api._successGetTemplates)
      }
      if ($scope.campaign.scheduledDate) {
        const scheduledDate = moment($scope.campaign.scheduledDate)
        const today = moment()
        $scope.isScheduled = scheduledDate > today

        if (!$scope.isScheduled) {
          $scope.campaign.scheduledDate = null
        }
      }
    }
  }

  $scope.getThumbnailUrl = template => {
    if (template.isCustomizable || template.thumbnailContentType || template.hasCover) {
      template.defaultThumb = false
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL, [template.id])
      const cached = Utils.fnAddQueryToUrl(url, { cache: template.updatedAt })
      return cached
    } else {
      template.defaultThumb = true
      return TemplateService.getDefaultThumbnail(template.extension)
    }
  }

  $scope.getArtCollectionThumbnail = function (campaign) {
    if (!campaign) {
      $scope.showDefaultThumb = true
      return '/assets/icons/files/img.svg'
    }

    const randomTemplateLength = Object.keys(campaign.random_template || {}).length

    if (!campaign.thumbnailS3Key && randomTemplateLength === 0) {
      $scope.showDefaultThumb = true
      return '/assets/icons/files/img.svg'
    } else if (!campaign.thumbnailS3Key && randomTemplateLength > 0) {
      $scope.showDefaultThumb = false
      return
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_THUMBNAIL, [campaign.id])
    const cached = Utils.fnAddQueryToUrl(url, { cache: campaign.updatedAt })

    return cached
  }

  function _successGetTemplates (templates) {
    if (templates.count) {
      $scope.templates = templates.rows
    }
  }
}

export { HomeCampaignsItemController }
